import { format } from 'date-fns';

const WEEKDAY_NAME_PATTERN = 'cccccc';

export const formatWeekdayName = (
    weekday: Date,
    options?: { locale?: Locale },
): string => {
    return format(weekday, WEEKDAY_NAME_PATTERN, options);
};
